export const canUseWebShare = () =>
  typeof navigator !== 'undefined' && typeof navigator.share === 'function';
